import Vue from "vue";
import Vuex from "vuex";
import AccountingProducts from "./modules_lib/accounting-products";
import Area from "./modules_lib/area";
import BillingSetting from "./modules_lib/billing-setting";
import DailyBillingSetting from "./modules_lib/daily-billing-setting";
import Contract from "./modules_lib/contract";
import Customer from "./modules_lib/customer";
import Markets from "./modules_lib/markets";
import Meter from "./modules_lib/meter";
import Product from "./modules_lib/product";
import User from "./modules_lib/user";
import Admin from "./modules_lib/admin";
import AccountingChart from "./modules_lib/accounting-chart";
import ProductCategory from "./modules_lib/product-category";
import Invoice from "./modules_lib/invoice";
import BankAccount from "./modules_lib/bank-account";
import Receipt from "./modules_lib/receipt";
import Employee from "./modules_lib/employee";
import ContractSuspendModule from "./modules_lib/contract-suspend";
import ContractDocumentModule from "./modules_lib/contract-document";
import ContractCheckoutModule from "./modules_lib/contract-checkout";
import AreaInterestModule from "./modules_lib/area-interest";
import QuotaionModule from "./modules_lib/quotaion";
import SnackbarModule from "./modules_lib/snackbar";
import ApproveTaskModule from "./modules_lib/approve-task";
import BillPaymentReportModule from "./modules_lib/bill-payment-report";
import AssetModule from "./modules_lib/asset";
import AssetCategoryModule from "./modules_lib/asset-category";
import ContractAssetModule from "./modules_lib/contract-asset";
import AreaAccountingProductModule from "./modules_lib/area-accounting-product"
import ContractTemplate from "./modules_lib/contract-template"
import Appeal from "./modules_lib/appeal"
import SettingTask from "./modules_lib/setting-task"
import ContractLog from "./modules_lib/contract-log"
import DigitalMeterReport from "./modules_lib/digital-meter-report"
import AreaBooking from "./modules_lib/area-booking"
import Booking from "./modules_lib/booking"
import BookingChannel from "./modules_lib/booking-channel"
import Companion from "./modules_lib/companion"
import Post from "./modules_lib/post"
import PasswordRecovery from "./modules_lib/password-recovery"
import Project from "./modules_lib/project"
import Comment from "./modules_lib/comment"
import MessageTemplate from "./modules_lib/message-template"
import CreditNote from "./modules_lib/credit-note"
import Socket from "./modules_lib/socket"
import IncomeExpense from "./modules_lib/income-expense"
import Expense from "./modules_lib/expense"
import TransactionCategory from "./modules_lib/transaction-category"
import QRPaymentReport from "./modules_lib/qr-payment-report"
import Income from "./modules_lib/income"
import MarketSetting from "./modules_lib/market-setting"
import SchedulerTask from "./modules_lib/scheduler-task"
import ProjectSetting from "./modules_lib/project-setting"
import DigitalMeter from "./modules_lib/digital-meter"
import Order from "./modules_lib/order"
import OrderLog from "./modules_lib/order-log"
import DigitalMeterLog from "./modules_lib/digital-meter-log"
import Overall from "./modules_lib/overall"
import QRPayment from "./modules_lib/qr-payment"
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user: User,
    markets: Markets,
    area: Area,
    customer: Customer,
    product: Product,
    contract: Contract,
    meter: Meter,
    accountingProducts: AccountingProducts,
    billingSetting: BillingSetting,
    dailyBillingSetting: DailyBillingSetting,
    admin: Admin,
    accountingChart: AccountingChart,
    productCategory: ProductCategory,
    invoice: Invoice,
    bankAccount: BankAccount,
    receipt: Receipt,
    employee: Employee,
    contractSuspend: ContractSuspendModule,
    contractDocument: ContractDocumentModule,
    contractCheckout: ContractCheckoutModule,
    areaInterest: AreaInterestModule,
    quotation: QuotaionModule,
    snackbar: SnackbarModule,
    approveTask: ApproveTaskModule,
    billPaymentReport: BillPaymentReportModule,
    asset: AssetModule,
    assetCategory: AssetCategoryModule,
    contractAsset: ContractAssetModule,
    areaAccountingProduct: AreaAccountingProductModule,
    contractTemplate: ContractTemplate,
    appeal: Appeal,
    settingTask: SettingTask,
    contractLog: ContractLog,
    digitalMeterReport: DigitalMeterReport,
    areaBooking: AreaBooking,
    booking: Booking,
    bookingChannel: BookingChannel,
    companion: Companion,
    post: Post,
    passwordRecovery: PasswordRecovery,
    project: Project,
    comment: Comment,
    messageTemplate: MessageTemplate,
    creditNote: CreditNote,
    socket: Socket,
    incomeExpense: IncomeExpense,
    expense: Expense,
    transactionCategory: TransactionCategory,
    qrPaymentReport: QRPaymentReport,
    income: Income,
    marketSetting: MarketSetting,
    schedulerTask: SchedulerTask,
    projectSetting: ProjectSetting,
    digitalMeter : DigitalMeter,
    order : Order,
    orderLog : OrderLog,
    digitalMeterLog : DigitalMeterLog,
    overall: Overall,
    qrPayment: QRPayment
  }
});
